﻿module Dashboard{
    class CsrSummary{

        responseToQuestion: string;
        returnUrl: string;
        baseUrl: string;
        csrlist: any[];

        constructor(
            private $scope: ng.IScope,
            private $q,
            private $routeParams,
            private scrollService,
            private $location,
            private dashboardCsrService
        ) {
            this.returnUrl = '/dashboard/csr/' + this.$routeParams.bookingId;
            this.baseUrl = '/dashboard';

            const killTheWatch = $scope.$watchCollection(() => this.csrlist,
                (val) => {
                    if (val && val.length > 0) {
                        killTheWatch();
                    }
                });
        }

        view(csr) {
            this.$location.path(this.baseUrl + '/csr-details/' + csr.BookingId + '/' + csr.CsrId);
        }

        getCsrStatusClass = status => this.dashboardCsrService.getCsrStatusClass(status);

    }


angular
    .module('dashboard')
    .directive('dashboardCsrSummary', (): ng.IDirective => {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            templateUrl: 'partials/dashboard/csrSummary',
            bindToController: {
                csrlist: '='
            },
            scope: {},
            controller: CsrSummary,
            controllerAs: 'cs'
        };
    });
}
